import React, {CSSProperties} from 'react';
import classNames from 'classnames';
import {setTestId} from 'js/reusable/testing/setTestId';

type IProps = {
	onToggle: React.ChangeEventHandler<HTMLInputElement>;
	className?: string;
	checked?: boolean;
	disabled?: boolean;
	containerClassName?: string;
	style?: CSSProperties;
	labelClassName?: string;
	testId?: string;
}

/**
    This component is only used on the self onboarding page, which has been removed from the application. When the
    component is removed the css should be as well. This includes many :before selectors with content: "<fa-icon>"

    @deprecated use ToggleButtonNew instead
*/
function ToggleButton(props: IProps) {
	return (
		<label
			className={classNames(
				'switch',
				props.containerClassName,
				props.labelClassName,
				{'tw-opacity-50 tw-cursor-not-allowed': props.disabled}
			)}
			style={props.style}
			data-testid={setTestId('toggle-button-' + props.testId)}
		>
			<input
				type="checkbox"
				checked={props.checked}
				readOnly
				onChange={props.onToggle}
				disabled={props.disabled}
			/>
			<span
				className={classNames(
					'slider round',
					props.className,
					{'tw-opacity-50 tw-cursor-not-allowed': props.disabled}
				)}
			>
				<i className="fa fa-pen" />
			</span>
		</label>
	);
}

export default ToggleButton;
